import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomeLandingPage from "./routes/HomeLandingPage";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeLandingPage />} />
      </Routes>
    </Router>
  );
}
